
import React from "react";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";

const Index = () => {
  return <DashboardLayout />;
};

export default Index;
